/**
 * @author omriha
 * 05/02/2020
 */
import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import queryString from 'query-string';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import ButtonContainer from '../../../components/Simple/ButtonContainer';
import {useEditorDimensions} from '../../../utils/hooks';
import LabelContainer from '../../../components/Page/LabelContainer';
import SMCEditor from '../../../components/Editor';
import SMCButton from '../../../components/Simple/SMCButton';
import {useServerGroupEditor} from './ServerGroupEditorHelper';
import RouteLeavingGuard from '../../PopupPages/RouteLeavingGuard';
import VerifyButtonsContainer from "../VerifyButtonsContainer";
import ButtonsContainerStyles from "../ButtonsContainerStyles";

/**
 * High level element to fetch, edit and save server group, all logic implemented inside.
 * @param {string} id Id of server group to fetch from the server group to edit
 */
function ServerGroupEditor({
    id,
    urlParams
}) {
    const { t } = useTranslation();
    const { editorWidth, editorHeight } = useEditorDimensions();
    const classes = ButtonsContainerStyles();

    let defaultPage = 'general';
    const queryParams = queryString.parse(urlParams);
    if (queryParams && queryParams['page']) {
        defaultPage = queryParams['page'];
    }

    const {
        serverGroupObject,
        isObjectDirty,
        editorPages,
        helpId,
        isPageDataLoaded,
        isInnerPageLoading,
        isPageLoadFailed,
        chosenPageId,
        errorMessagesByPageList,
        onPageChange,
        setServerGroupData,
        reloadButtonOnClick,
        saveButtonOnClick,
        deleteButtonOnClick,
        revertButtonOnClick,
        reloadPageData
    } = useServerGroupEditor(id, defaultPage);
    
    // Data passed down to the editor pages
    const editorPageData = {
        serverGroupObject,
        setEditorPageId: onPageChange,
        setServerGroupData,
        reloadButtonOnClick,
        isPageDataLoaded,
    }

    return (
        <>
        <RouteLeavingGuard when={isObjectDirty} />
        <SMCPage loading={!isPageDataLoaded} helpId={helpId}>
            <div className="ObjectEditor" style={{ width: editorWidth }}>
                {/* Header */}
                <div className="ObjectEditorHeader">
                    <ButtonContainer>
                        <SMCButton labelClassName={classes.labelColor} icon="delete" variant="ghost" disabled={!isPageDataLoaded} onClick={deleteButtonOnClick}>{t('SMC_GEN_DELETE')}</SMCButton>
                    </ButtonContainer>
                    <LabelContainer label="Name:" value={id} />
                </div>
                {/* Make a navigation tree here */}
                <SMCEditor
                    editorPageData={editorPageData}
                    height={editorHeight}
                    width={editorWidth}
                    errorListByPage={errorMessagesByPageList}
                    chosenPageId={chosenPageId}
                    onPageChange={onPageChange}
                    isPageLoaded={isPageDataLoaded && !isInnerPageLoading}
                    isPageLoadFailed={isPageLoadFailed}
                    reloadData={reloadPageData}
                    pages={editorPages}
                />
            </div>
        </SMCPage>
            <VerifyButtonsContainer
                disabled={!isPageDataLoaded}
                onClickSaveButton={saveButtonOnClick}
                onClickCancelButton={revertButtonOnClick}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(ServerGroupEditor);